module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 var cls = "";
   if ( net_allocated > net_revised ) {
       cls = "decreased";
   } else if ( net_revised > net_allocated ) {
       cls = "increased";
   } else {
       cls = "unchanged";
   }
 ;
__p += '\n<div class="widget-popover-sums">\n  <span class="approved">\n    ' +
((__t = ( format_full_number( net_allocated*1000 ) )) == null ? '' : __t) +
' ₪\n  </span>\n  <span class="' +
((__t = ( cls )) == null ? '' : __t) +
'">\n    &lrm;' +
((__t = ( number_plus_minus(net_revised - net_allocated) )) == null ? '' : __t) +
'' +
((__t = ( Math.abs( (1 - (1.0*net_revised)/net_allocated) * 100).toFixed(1) )) == null ? '' : __t) +
'% &rlm;\n  </span>\n</div>\n<p class="description">\n' +
((__t = ( explanation == null? "" : explanation )) == null ? '' : __t) +
'\n</p>\n<span class="history increased">\n';
 var styc = analysis_short_term_yearly_change;;
__p += '\n';
 if (styc != null ) { ;
__p += '\n    ';
 if (styc > 0) { ;
__p += '\n    מ-2009 גדל התקציב לאורך השנה בכ-' +
((__t = ( styc )) == null ? '' : __t) +
'%\n    ';
 } ;
__p += '\n    ';
 if (styc < 0) { ;
__p += '\n    מ-2009 ' +
((__t = ( -styc )) == null ? '' : __t) +
'% מהתקציב מועבר למטרות אחרות\n    ';
 } ;
__p += '\n';
 } ;
__p += '\n</span>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/searchbar-tooltip-full.html
// module id = 139
// module chunks = 0